import "../assets/css/shiny.scss";
import { useState, useEffect } from "react";
import LoadingComponent from "./loading";
import { handleImageModal } from "./blog_modal";
import Modal from "./blog_modal";

export default function Shiny() {
  const [allShinies, setAllShinies] = useState(null);
  const [modalState, setModalState] = useState(null);

  useEffect(() => {
    const url = "https://cms.madebyparry.com/api/v1/shiny?_format=json";
    const options = {
      method: "GET",
    };
    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setAllShinies(Object.values(data));
        console.log("got response ->", data);
      })
      .catch((error) => console.log(error));
  }, []);

  if (allShinies === null) {
    return <LoadingComponent />;
  } else {
    return (
      <div className="shiny-container">
        <div className="shiny-header">
          <h1>✨ Shinies ✨</h1>
        </div>
        <div className="shiny-wrapper">
          {allShinies.map((shiny, index) => {
            if (shiny.post_images_preview !== null) {
              shiny.post_images_preview_array =
                shiny.post_images_preview.split(", ");
              shiny.post_images_array = shiny.post_images.split(", ");
            }
            const allImages = allShinies.map((post) => post.post_images_array);
            console.log(shiny.post_images_array);
            return (
              <div key={index} className="shiny-item">
                <h3 className="shiny-title">{shiny.title}</h3>
                <div className="shiny-images">
                  {shiny.post_images_preview_array.map((img, index_inner) => {
                    return (
                      <img
                        key={index_inner}
                        src={`https://cms.madebyparry.com${img}`}
                        onClick={() =>
                          handleImageModal(
                            {
                              image: `https://cms.madebyparry.com${shiny.post_images_array[index_inner]}`,
                              index: index,
                            },
                            setModalState,
                          )
                        }
                      />
                    );
                  })}
                </div>
                <div className="shiny-author">
                  <p>- {shiny.name}</p>
                  <p>{shiny.created.split(",")[0]}</p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="button-wrapper">
          <a className="button" href="/parry_news">
            Back to posts
          </a>
        </div>
        <Modal
          modalState={modalState}
          setModalState={setModalState}
          imageList={allShinies.map((post) => post.post_images_array)}
        />
      </div>
    );
  }
}
